import React, { useEffect } from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import PaperAirplane from 'assets/illustrations/Plane-Crash.png';
import QButton from 'components/QButton';
import ReportProblemLink from 'components/ReportProblemLink';
import { dismissErrorPage } from 'utils/core/bugsnag';

import styles from './styles';

const useStyles = makeStyles()(styles);

const FallbackComponent = (_props) => {
  const { classes } = useStyles();
  useEffect(() => dismissErrorPage(), []);

  return (
    <div className={classes.parentContainer}>
      <img alt='paper-airplane' src={PaperAirplane} className={classes.paperAirplane} />

      <Typography variant='displayRegular' className={classes.textItem}>
        Oops! Something went wrong.
      </Typography>

      <Typography variant='titleRegular' className={classes.textItemSubtitle}>
        We are sorry for the inconvenience.
        <br />
        {"Rest assured, we're working to fix this issue."}
      </Typography>

      <QButton variant='outlined' onClick={() => window.location.reload()} className={classes.tryAgainButton}>
        Try Again
      </QButton>

      <ReportProblemLink type='button' feedbackSubject='report react crash' className={classes.reportProblem}>
        SEND FEEDBACK
      </ReportProblemLink>
    </div>
  );
};

FallbackComponent.whyDidYouRender = false;

export default FallbackComponent;
